// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3bGC5","header":"PatientBlock_header__13d7h","label":"PatientBlock_label__2IHGA","option":"PatientBlock_option__tN17_"};